/*
 * @Description: 
 * @Date: 2020-09-27 10:03:21
 * @LastEditors: jml
 */
export const dealTime = (value) => {
  if (value == 0) {
    return "000.00";
  }
  if (value > 99999) {
    return "999.99";
  }
  const d = (value / 100).toFixed(2);
  return `${d}`.padStart(6, 0);
};
